import { defineComponent, ref } from "vue";
import { definePropType } from "@types-vue/props";
import Draggable from "vuedraggable";
import FrameSequence from "@/components/FrameSequence/index.vue";
export default defineComponent({
    props: {
        // 图片数据
        currentFrame: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        // 允许选中的数量
        count: {
            type: Number,
            default: 0
        },
        // 默认值
        defaultValue: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Draggable: Draggable,
        FrameSequence: FrameSequence
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var handleDragStart = function handleDragStart() {
            dragMove.value = true;
        };
        var handleDragEnd = // 移动图片位置
        function handleDragEnd() {
            // DragEnd 时 currentFrame 已经被更新了
            dragMove.value = false;
            frameSort();
        };
        var frameSort = // 帧图片排序
        function frameSort() {
            var _loop = function(i) {
                if (multipleSelection.value.some(function(item) {
                    return item.id === props.currentFrame[i].id;
                })) {
                    list.push(props.currentFrame[i]);
                }
            };
            var list = [];
            for(var i = 0; i < props.currentFrame.length; i++)_loop(i);
            multipleSelection.value = list;
            emit("change", multipleSelection.value);
        };
        var multipleSelection = ref(props.defaultValue);
        var dragMove = ref(false);
        var isChecked = function(id) {
            return multipleSelection.value.some(function(item) {
                return item.id === id;
            });
        };
        var disabledCheck = function(id) {
            return multipleSelection.value.length >= props.count && !multipleSelection.value.some(function(item) {
                return item.id === id;
            });
        };
        var disabledPopper = function(id) {
            var _$ref;
            return dragMove.value || multipleSelection.value.length < props.count || multipleSelection.value.length >= props.count && ((_$ref = multipleSelection.value) === null || _$ref === void 0 ? void 0 : _$ref.some(function(item) {
                return item.id === id;
            }));
        };
        var handleCheckConfig = function(item) {
            var index = multipleSelection.value.findIndex(function(val) {
                return val.id === item.id;
            });
            if (index !== -1) {
                multipleSelection.value.splice(index, 1);
            } else {
                if (multipleSelection.value.length >= props.count) {
                    return;
                }
                multipleSelection.value.push(item);
                // 增加数据时需要重新排序
                frameSort();
            }
        };
        // 序列帧展示
        var getXlzImages = function() {
            return multipleSelection.value.map(function(item) {
                return item.url;
            });
        };
        return {
            multipleSelection: multipleSelection,
            isChecked: isChecked,
            disabledCheck: disabledCheck,
            disabledPopper: disabledPopper,
            handleCheckConfig: handleCheckConfig,
            handleDragEnd: handleDragEnd,
            handleDragStart: handleDragStart,
            getXlzImages: getXlzImages
        };
    }
});
